export default __webpack_public_path__ + "static/media/609.f37db061.gif";